import { ENTITY_TYPES, type EntityType } from '@/lib/constants/entity-types';
import type { EntityProfileModule } from './types';
import { startupProfileModule } from './modules/startup';
import { investorProfileModule } from './modules/investor';
import { partnerProfileModule } from './modules/partner';

/**
 * The single linking point: entity type -> typed profile module (ADR FE-1).
 * The `Record<EntityType, ...>` makes every type exhaustive; adding a 4th type
 * is one line here and nothing else changes.
 *
 * The value generic is intentionally `any`: each module is internally typed to
 * its own data shape, but they differ per type, so the registry erases the
 * generic at the boundary (a `Record<EntityType, EntityProfileModule<unknown>>`
 * would reject the modules under strict function-parameter variance).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- see doc comment
export const profileRegistry: Record<EntityType, EntityProfileModule<any>> = {
  [ENTITY_TYPES.STARTUP]: startupProfileModule,
  [ENTITY_TYPES.INVESTOR]: investorProfileModule,
  [ENTITY_TYPES.TRUSTED_PARTNER]: partnerProfileModule,
};
